import { render } from "./Carusel.vue?vue&type=template&id=fbfd98a0&scoped=true"
import script from "./Carusel.vue?vue&type=script&lang=js"
export * from "./Carusel.vue?vue&type=script&lang=js"

import "./Carusel.vue?vue&type=style&index=0&id=fbfd98a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfd98a0"]])

export default __exports__